import React, {useState, useEffect} from "react";
import {Typography, Box, Pagination, TextField, InputAdornment} from "@mui/material";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";
import ListDriverComponent from "../components/list-driver.component";
import useDriver from "../hooks/useDriver";
import CustomButton from "../../../core/components/ui/CustomButton";
import CreateDriverComponent from "../components/create-driver.component";
import AddIcon from "@mui/icons-material/Add";
import CustomModal1 from "../../../core/components/ui/custom-modal1.component";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
import { useNavigate } from "react-router-dom";
import  useDriverStore  from "../zustand/useDriverStore";
import { RBACUIGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../../core/components/layout/theme";
import Select from "react-select";

const headers = [
    {label: "Driver"},
  { label: "ID Number" },
  { label: "ID Type" },
  { label: "Role" },
  { label: "Profile Type" },
  { label: "Status" },
  { label: "Created At" },
  { label: "Actions" },
];

const customStyles = {
  control: (base, state) => ({
    ...base,
    height: 42,
    width: 250,
    fontSize: 14,
    backgroundColor: "transparent",
    borderColor: state.isFocused
      ? theme.palette.primary.main
      : "#dce8f5",
    boxShadow: state.isFocused
      ? `0 0 0 1px ${theme.palette.primary.main}`
      : "none",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 12,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 99999,
    fontSize: 14,
  }),
};

const searchOptions = [
  { value: "email", label: "Email" },
  { value: "firstname", label: "First Name" },
  { value: "lastname", label: "Last Name" },
];

const DriverPage = (props) => {
    const {isMobile, breakpoints} = props;

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const org_uid = rbacStorage?.state?.currentProfile?.orgId;
    
    const view_org_uid = new URLSearchParams(window.location.search).get("org_uid");

    const organizationId = view_org_uid || org_uid;

    const {getDriverList, driverList, isFetchingDriverList, listDriverFilter, filterDriverList} = useDriver();
    const { isSuccess} = useDriverStore();

    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchField, setSearchField] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [isFiltering, setIsFiltering] = useState(false);

    const navigate = useNavigate();

    const rowsPerPage = 10;

    const handleFieldChange = (selectedOption) => {
        setSearchField(selectedOption);
        setSearchValue("");
        setCurrentPage(1);
    };

    const handleSearch = () => {
        if (searchField && searchValue) {
        setIsFiltering(true);
        setCurrentPage(1);
        listDriverFilter({
            searchFor: searchField.value,
            searchVal: encodeURIComponent(searchValue),
            page: currentPage,
            limit: rowsPerPage,
            org_uid: organizationId,
        });
        }
    };

    const handleClearSearch = () => {
        setSearchValue("");
        setSearchField(null);
        setIsFiltering(false);
        setCurrentPage(0);
        getDriverList({organizationId,  page: 1});
    };

    useEffect(() => {

        if(isFiltering && searchField && searchValue) {
            filterDriverList({
                searchFor: searchField.value,
                searchVal: encodeURIComponent(searchValue),
                page: currentPage,
                limit: rowsPerPage,
                org_uid: organizationId,
            })
        } else {
            const parameters = {
                page: currentPage,
                limit: rowsPerPage,
                org_uid: view_org_uid || org_uid,
            }
            getDriverList(parameters)
        }


        // const parameters = {
        //     page: currentPage,
        //     limit: rowsPerPage,
        //     org_uid: view_org_uid || org_uid,
        // }

        //     getDriverList(parameters)
        
    }, [org_uid,currentPage])

    useEffect(() => {
        if (isSuccess) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                org_uid: view_org_uid || org_uid,
            }
            getDriverList(parameters)
        }
    }, [isSuccess])

    const handleChangePagination = (event, page) => { 
        setCurrentPage(page); 
    }

    let create_driver = '/driver/create';

    if (!org_uid && view_org_uid) {
    create_driver = `/organization/driver/create?org_uid=${view_org_uid}`;
    }


    return (
        <>        
            <Box display="flex" sx={{alignItems:'center'}}>
                <Box>
                <CustomTypography variant="h3" text={"Drivers"} customStyles={{ marginBottom: 0 }} />
                <CustomTypography
                    variant="subtitle1"
                    text={"Effectively manage driver profiles, assignments, and credentials."}
                    customStyles={{ marginBottom: 0 }}
                />
                </Box>
            </Box> 

            <Box sx={{ display: "flex", alignItems: "center", justifyContent:'end'}}>
               
                {/* <RBACUIGuard requiredPermission={permissions.drivers.LIST_SEARCH_DRIVER_USER}> */}
                    <Select
                    styles={customStyles}
                    options={searchOptions}
                    value={searchField}
                    onChange={handleFieldChange}
                    placeholder="Select filter"
                    />
                    &nbsp;&nbsp;
                    {searchField && (
                    <TextField
                        placeholder={searchField.label}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearch();
                        }}
                        variant="outlined"
                        autoComplete="off"
                        sx={{
                        "& .MuiInputBase-root": {
                            height: 42,
                            width: 300,
                            backgroundColor: "transparent",
                            mr: 1,
                        },
                        }}
                        InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                            <Typography sx={{ fontSize: 12 }}>Search:</Typography>
                            </InputAdornment>
                        ),
                        endAdornment: searchValue && (
                            <InputAdornment
                            position="end"
                            sx={{ cursor: "pointer" }}
                            onClick={handleClearSearch}
                            >
                            <CloseIcon fontSize="small" />
                            </InputAdornment>
                        ),
                        style: {
                            padding: "10px",
                            fontSize: 14,
                            fontStyle: "italic",
                        },
                        }}
                    />
                    )}
                {/* </RBACUIGuard> */}
                
                
                &nbsp;&nbsp;
                    <RBACUIGuard requiredPermission={permissions.drivers.CREATE_DRIVER}>
                        <CustomButton
                        onClick={() => navigate(create_driver)}
                        variant="contained"
                        startIcon={<AddIcon fontSize="small" />}
                        label="Add Driver"
                        customStyles={{ fontSize: 14}}
                        />
                    </RBACUIGuard>
                </Box>

            {isFetchingDriverList ?
                <Box sx={{mt: 3}}>
                    <CustomTableLoaderComponent headers={headers} hasAction={false} />
                </Box>
            :   
                <Box sx={{mt: 3}}>
                    <ListDriverComponent
                        headers={headers} 
                        data={isFiltering ? filterDriverList : driverList} 
                        isMobile={isMobile}
                        breakpoints={breakpoints}
                        org_uid={org_uid}
                    />

                    <Box textAlign="center" mt={3} display="flex" justifyContent="center" gap={2}>
                        <CustomButton
                            label="Back"
                            variant="outlined"
                            disabled={currentPage <= 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            customStyles={{ fontSize: 14, px: 4 }}
                        />
                        <CustomButton
                            label="Load More"
                            variant="outlined"
                            disabled={isFetchingDriverList || driverList.length < rowsPerPage}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            customStyles={{ fontSize: 14, px: 4 }}
                        />
                    </Box>

                </Box>
            }
            {/* <CustomModal1
                open={addDialogOpen}
                handleClose={() => setAddDialogOpen(false)}
                title="Add Driver"
            >
                <CreateDriverComponent
                    handleClose={() => setAddDialogOpen(false)}
                    handleUpdateList={handleUpdateList}
                />
            </CustomModal1> */}
       </>
    )
}

export default DriverPage